var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUiSwiperArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 41,
    viewBox: "0 0 24 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.712 21.137a.981.981 0 010-1.403l2.186-2.152L23 36.389l-2.898 2.854L1.712 21.137z",
    fill: "#292929",
    stroke: "#292929",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.001 4.48l-2.898-2.853L1 20.434l2.186 2.152a1.019 1.019 0 001.425 0L23.001 4.48z",
    fill: "#292929",
    stroke: "#292929",
    strokeWidth: 1.25
  })));
}
export default SvgUiSwiperArrow;